import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import { resolveApiAssetUrl } from '../lib/api';
import { brandLogoTexts } from '../lib/brand';

const Logo = ({ size = 'md', linked = true }) => {
  const s = useSettings();
  const [imageFailed, setImageFailed] = useState(false);
  const sizes = { sm: 'text-xl', md: 'text-2xl md:text-3xl', lg: 'text-4xl' };
  const imageSizes = { sm: 'h-7', md: 'h-8 md:h-10', lg: 'h-12' };
  const skeletonSizes = { sm: 'h-5 w-16', md: 'h-6 w-24 md:h-7 md:w-28', lg: 'h-9 w-36' };
  // Ayarlar gelmeden marka önbellekten okunur; hiç bilinmiyorsa "Site" gibi
  // yanlış bir ad yazmak yerine yer tutucu çizilir (bkz. lib/brand.js).
  const { primary, secondary } = brandLogoTexts(s);
  const showImage = Boolean(s.logo_image_url) && !imageFailed;

  useEffect(() => {
    setImageFailed(false);
  }, [s.logo_image_url]);

  const textLogo = primary ? (
    <>
      <span className={`font-black tracking-tight ${sizes[size] || sizes.md} gold-text`}>{primary}</span>
      <span className={`font-black tracking-tight ${sizes[size] || sizes.md} text-white`}>{secondary}</span>
    </>
  ) : (
    <span
      className={`brand-skeleton rounded-md ${skeletonSizes[size] || skeletonSizes.md}`}
      aria-hidden="true"
    />
  );
  const content = showImage ? (
    <img
      src={resolveApiAssetUrl(s.logo_image_url)}
      alt={s.site_name || `${primary}${secondary}` || 'Logo'}
      className={`${imageSizes[size] || imageSizes.md} w-auto max-w-[220px] object-contain`}
      onError={() => setImageFailed(true)}
    />
  ) : textLogo;

  if (!linked) {
    return <span className="flex items-center select-none">{content}</span>;
  }

  return <Link to="/" className="flex items-center select-none">{content}</Link>;
};

export default Logo;
